export default __webpack_public_path__ + "static/Gaggenau-08-Bold-c0304691437fae8dabdcb94b270b8da2.woff2";